import { Colors, mediaQueries } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  padding: 16px;
  border: 1px dashed ${Colors.GS500};
  position: relative;
`;
export const Inner = styled.div `
  display: grid;
  gap: 20px;
  grid-auto-flow: column;
  grid-template-columns: 120px 1fr;

  ${mediaQueries.tablet} {
    gap: 30px;
    grid-template-columns: 140px 1fr;
  }
`;
export const Info = styled.div `
  display: grid;
  gap: 8px;
  justify-items: flex-start;
  align-content: center;
`;
export const Shape = styled.div `
  background-color: ${Colors.GS200};
  border-radius: 4px;
`;
export const ButtonContainer = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
